<template lang="pug">
md-layout(md-flex='100')
  md-layout(md-flex='90', md-flex-offset='5')
    md-card.md-table-card.content-table
      form.search-form(novalidate, @submit.stop.prevent='resetPaginationAndSearch')
        md-layout(:md-gutter='24', md-flex='100')
          md-layout(md-flex='20', md-flex-small='100')
            md-input-container
              label(for='criteria') Metric
              md-select#criteria(v-model='filters.e', @selected='resetPaginationAndSearch')
                md-option(value='feedloaded') Feeds Loaded
                md-option(value='contentStart') Content Starts
          md-layout(md-flex='28', md-flex-small='40', md-flex-xsmall='50')
            date-input(v-model='filters.startdate', :validation='$v.filters.startdate', :formSubmitted='true', label="From date")
          md-layout(md-flex='28', md-flex-small='40', md-flex-xsmall='50')
            date-input(v-model='filters.enddate', :validation='$v.filters.enddate', :formSubmitted='true', label="To date")
          md-layout(md-flex='5', md-flex-small='20', md-flex-xsmall='100', md-align-xsmall='center')
            md-button.search-btn.md-icon-button.btn(type='submit', :disabled='loading || $v.$invalid')
              md-icon.icon(md-iconset="fa fa-search")
          md-layout#total-views(md-flex='25', md-flex-small='100', md-align='end')
            transition(
              name='bounce'
              enter-active-class='animated bounceIn'
              leave-active-class='animated bounceOut'
            )
              span#totalViews.md-subheading(v-show='totalViews > 0 && !loading') Total views: {{ formattedTotalViews }}

        md-layout(md-flex='100')
          md-layout(md-flex='70', md-flex-small='100')
            a.filter-link.md-primary(@click='getFrom("today")') Today
            a.filter-link.md-primary(@click='getFrom("yesterday")') Yesterday
            a.filter-link.md-primary(@click='getFrom("last_week")') Last 7 days
            a.filter-link.md-primary(@click='getFrom("this_month")') This month
            a.filter-link.md-primary(@click='getFrom("last_month")') Last month
          md-layout(md-flex='30', md-flex-small='100', md-align='end')
            md-button.md-primary.md-raised.md-dense(md-theme='rhebus-blue', @click='exportCSV', :disabled='loading || $v.$invalid') Export CSV


      stitch-loader(:loading='loading', :size='45')
        .table(v-if='logs.length > 0') 
          div.titleLine.styleRow
            p.rowElements.sortable(@click = "onSort('date')") Date {{sort.name === 'date' ? sort.type === 'desc' ? '&darr;' : '&uarr;' : ''}}
            p.rowElements.sortable(@click = "onSort('distribution.name')") Distribution {{sort.name === 'distribution.name' ? sort.type === 'desc' ? '&darr;' : '&uarr;' : ''}}
            p.rowElements.sortable(@click = "onSort('content.name')", v-if='filters.e === "timeupdate"') Distribution {{sort.name === 'content.name' ? sort.type === 'desc' ? '&darr;' : '&uarr;' : ''}}
            p.rowElements.sortable(@click = "onSort('geo')") Distribution {{sort.name === 'geo' ? sort.type === 'desc' ? '&darr;' : '&uarr;' : ''}}
            p.rowElements.sortable(@click = "onSort('platform')") Platform {{sort.name === 'platform' ? sort.type === 'desc' ? '&darr;' : '&uarr;' : ''}}
            p.rowElements.sortable(@click = "onSort('views')") Views {{sort.name === 'views' ? sort.type === 'desc' ? '&darr;' : '&uarr;' : ''}}
          div.styleRow.colorHover(v-for='log in logs', :key='log._id')
            div.rowElements {{ log.date }}
            div.rowElements {{ log.distribution }}
            div.rowElements(v-if='filters.e === "timeupdate"')
              span {{ log.mediaItem ? log.mediaItem : '-' }}
            div.rowElements {{ log.country }}
            div.rowElements {{ log.platform }}
            div.rowElements {{ log.views }}

          //- md-table(:md-sort='sort.name', :md-sort-type='sort.type', @sort='onSort')
            md-table-header
              md-table-row
                md-table-head(md-sort-by='date') Date
                md-table-head(md-sort-by='distribution.name') Distribution
                md-table-head(md-sort-by='content.name', v-if='filters.e === "timeupdate"') Distribution
                md-table-head(md-sort-by='geo') Distribution
                md-table-head(md-sort-by='platform') Platform
                md-table-head(md-sort-by='views') Views
            md-table-body
              md-table-row(v-for='log in logs', :key='log._id')
                md-table-cell {{ log.date }}
                md-table-cell {{ log.distribution }}
                md-table-cell(v-if='filters.e === "timeupdate"')
                  span {{ log.mediaItem ? log.mediaItem : '-' }}
                md-table-cell {{ log.country }}
                md-table-cell {{ log.platform }}
                md-table-cell {{ log.views }}


          md-table-pagination(
            :md-size='currentPagination.size',
            :md-total='totalLogs',
            :md-page='currentPagination.page',
            md-label='Logs',
            md-separator='of',
            :md-page-options='[10, 25, 50, 100]',
            @pagination='onPageChanged'
          )

        md-layout(v-else='', md-align='center')
          span#no-results.md-subheading
            md-icon.md-accent(md-iconset="fa fa-exclamation-circle")
            | No items to show
</template>

<script>
  import moment from 'moment';
  import Period from '../../common/utils/periods';
  import { validationMixin } from 'vuelidate';
  import reportService from '../../services/reportService';
  import stitchLoader from '../../shared-components/Loader';
  import DateInput from '../../shared-components/forms/DateInput';
  import { isValidDate } from '../../services/validatorService';

  export default {
    mixins: [validationMixin],
    components: {
      DateInput,
      stitchLoader
    },
    data() {
      return {
        logs: [],
        totalLogs: 0,
        totalViews: 0,
        loading: false,
        currentPagination: {
          page: 1,
          size: 10
        },
        sort: {
          name: 'date',
          type: 'asc'
        },
        filters: {
          e: 'feedloaded',
          startdate: '',
          enddate: ''
        }
      };
    },
    validations: {
      filters: {
        startdate: {
          isValidDate(value) {
            return isValidDate(value);
          }
        },
        enddate: {
          isValidDate(value) {
            return isValidDate(value);
          }
        }
      }
    },
    computed: {
      searchParams() {
        const params = {
          e: this.filters.e,
          offset: this.currentPagination.size * (this.currentPagination.page - 1),
          limit: this.currentPagination.size,
          sortkey: this.sort.name,
          sortorder: this.sort.type === 'asc' ? 1 : -1
        };
        const { startdate, enddate } = this.filters;
        if (startdate) {
          Object.assign(params, { startdate });
        }
        if (enddate) {
          Object.assign(params, { enddate });
        }
        return params;
      },
      formattedTotalViews() {
        return this.totalViews.toLocaleString();
      }
    },
    methods: {
      resetPaginationAndSearch() {
        this.currentPagination.page = 1;
        this.search();
      },
      onPageChanged(paginationParams) {
        this.currentPagination = paginationParams;
        this.search();
      },
      onSort(sortParams) {
        this.sort.name = sortParams;
        this.sort.type = this.sort.type === 'desc' ? 'asc' : 'desc';
        this.resetPaginationAndSearch();
      },
      getFrom(period) {
        const { startDate, endDate } = Period.periods(period);
        this.filters.startdate = startDate;
        this.filters.enddate = endDate;
        this.resetPaginationAndSearch();
      },
      search() {
        this.loading = true;
        reportService.getList(this.searchParams)
          .then((response) => {
            const data = response.data.logs[0];
            if (data) {
              this.logs = data.logs;
              this.totalLogs = data.count;
              this.totalViews = data.totalViews;
              this.logs.forEach((log) => {
                log.date = moment.utc(log.date).format('MM-DD-YYYY');
              });
            } else {
              this.logs = [];
              this.totalLogs = 0;
              this.totalViews = 0;
            }
          })
          .catch((error) => {
            console.error('Error while retrieving the list of logs', error);
          })
          .then(() => {
            this.loading = false;
          });
      },
      exportCSV() {
        this.loading = true;
        const params = Object.assign({}, this.searchParams, { export: 1 });
        reportService.getList(params)
          .then((response) => {
            const blob = new Blob([response.data], { type: 'text/csv' });
            const url = window.URL.createObjectURL(blob);
            const hiddenLink = document.createElement('a');
            document.body.appendChild(hiddenLink);
            hiddenLink.style.display = 'none';
            hiddenLink.href = url;
            hiddenLink.download = 'report.csv';
            hiddenLink.click();
            window.URL.revokeObjectURL(url);
          })
          .catch((error) => {
            console.error('Error while getting the CSV file', error);
          })
          .then(() => {
            this.loading = false;
          });
      },
      mounted() {
        this.search();
      }
    }
  };
</script>

<style lang="scss" scoped>
  .search-form {
    margin-top: 20px;
    width: 100%;
  }
  .table {
    margin-top: 20px;
  }
  .content-table {
    width: 100%;
    margin-top: 20px;
    padding-left: 10px;
    padding-right: 10px;
  }
  .md-table {
    .md-sortable.md-sorted, .md-sortable:hover {
      color: #0198cf;
    }
  }
  #no-results {
    padding: 20px;
    .md-icon {
      margin-right: 5px;
    }
  }
  #total-views {
    .md-subheading {
      padding-top: 25px;
    }
  }

  .styleRow p {
  font-weight: 600;
}
.rowElements {
  flex: 1;
  padding: 6px 32px 6px 24px;
}
.colorHover:hover{
  background-color: #eee;
}


.titleLine {
  padding: 0px;
  border-bottom: 1 px solid rgba(153, 155, 155, 0.486);
}

.sortable:hover{
  cursor: pointer;
  color: #4ea9dd;
}
</style>



// WEBPACK FOOTER //
// src/shared-components/report/ReportTable.vue